import moment from 'jalali-moment';

import { toEnglishDigits } from '../../utils/methods';
import { parseCourseCapacity } from './courseUtils';

export const IN_PERSON_DETAIL_FIELDS = [
	'instructor_name', 'start_date', 'end_date', 'schedule',
	'sessions_count', 'total_hours', 'venue', 'registration_deadline'
];

/** Keep form drafts as strings while dates travel over the API as Gregorian ISO days. */
export const getInPersonCourseDetails = (course = {}) => Object.fromEntries(
	IN_PERSON_DETAIL_FIELDS.map(field => [field, course[field] == null ? '' : String(course[field])])
);

/** Accept localized decimal hours without truncating fractions or allowing signed/exponent input. */
export const parseCourseHours = value => {
	const normalized = toEnglishDigits(String(value ?? '').trim()).replace(/٫/g, '.');
	if(!/^(?:\d+(?:\.\d+)?|\.\d+)$/.test(normalized))
		return null;
	const hours = Number(normalized);
	return Number.isFinite(hours) && hours > 0 ? hours : null;
};

/** Validate all attendance fields independently of native form validation. */
export const parseInPersonCourseDetails = draft => {
	const details = getInPersonCourseDetails(draft);
	for(const field of IN_PERSON_DETAIL_FIELDS) {
		details[field] = details[field].trim();
		if(!details[field])
			return { error: 'course_in_person_details_required' };
	}
	for(const field of ['start_date', 'end_date', 'registration_deadline']) {
		if(!/^\d{4}-\d{2}-\d{2}$/.test(details[field]) || !moment(details[field], 'YYYY-MM-DD', true).isValid())
			return { error: 'course_dates_invalid' };
	}
	if(details.start_date > details.end_date)
		return { error: 'course_dates_order_invalid' };
	details.sessions_count = parseCourseCapacity(details.sessions_count);
	if(details.sessions_count === null)
		return { error: 'course_sessions_count_invalid' };
	details.total_hours = parseCourseHours(details.total_hours);
	if(details.total_hours === null)
		return { error: 'course_total_hours_invalid' };
	return { details };
};

/** Online course requests never persist stale attendance information. */
export const emptyInPersonCoursePayload = () => Object.fromEntries(IN_PERSON_DETAIL_FIELDS.map(field => [field, null]));
